<IziGrid class="left-hall-container">
  <IziCol xl="12">
    <FilterChallenge />
  </IziCol>
  <IziCol xl="12">
    <TopChallenge />
  </IziCol>
  <IziCol class="title">
    <span>Can't find what you want?</span>
  </IziCol>
  <IziCol>
    <IziButton card="true" label="Create A Challenge" buttonType="primary" theme="outlined" @click="openCreateChallenger"/>
  </IziCol>
  <IziCol class="footer-left-hall">
    <hr>
    <p class="title">
      Think you have better questions for challenge?<br>
      Shout-out to us!
    </p>
    <IziButton card="true" label="Sure, Izi Contact me" buttonType="primary" theme="outlined" />
  </IziCol>
</IziGrid>